import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/siburenhi-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function Siburenhi(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Реконструкция Центра НИОКР ООО «СИБУР Инновации»</span><br /> на территории инновационного центра «Сколково»</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Обеспечить электроснабжение нового производственного оборудования.</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «ЭНХИ».</p>
                            <p><strong>Конечный заказчик: </strong>ООО «Сибур Полилаб».</p>
                            <p><strong>Дата: </strong>март 2026 г.</p>
                            <p><strong>Срок выполнения: </strong>10 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Обеспечено электроснабжение нового производственного оборудования без остановки действующего технологического процесса.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Выполнена модернизация существующего ГРЩ: добавлена дополнительная секция (панель) с автоматическим выключателем 630 А.</li>
                                <li>Смонтирован новый распределительный шкаф (ШР) для питания вновь устанавливаемого оборудования.</li>
                                <li>Проложена кабельная линия от ГРЩ до нового ШР.</li>
                                <li>От смонтированного ШР подключено оборудование заказчика по двум групповым кабельным линиям.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}